"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = require("./events");
exports.events = events_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@sparrow-vue/sparrow-utils/dist/index.js
// module id = 72
// module chunks = 0